<template>
  <div class="tabmenu-wrapper" :class="{ btns: useBtn }">
    <div class="tab-list">
      <div v-for="(tab, index) in tabList" :key="index" class="tab-item">
        <input
          :id="`radio-${id}-${index}`"
          type="radio"
          :name="id"
          :value="index + 1"
          :checked="index + 1 === value ? true : false"
          :disabled="disabled"
          @input="$emit('input', Number($event.target.value))"
        />
        <!--           @click="onLink(index + 1)" -->
        <label class="tab-label" :for="`radio-${id}-${index}`"
          >{{ tab.label }}
        </label>
      </div>
      <div class="tab-item" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      default: 'defaultId'
    },
    // v-model
    value: {
      type: Number,
      default: 1
    },
    useBtn: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'if'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      tabIndex: this.value
    }
  },
  methods: {
    onLink(index) {
      this.tabIndex = index
      this.$emit('input', index)
    }
  }
}
</script>
